/**
 * Quick Add to Cart functionality for product cards
 * Shows size selector and add to cart button on hover (desktop)
 * Shows modal on mobile when clicking icon
 */
(function() {
    'use strict';

    // Modal elements
    const modal = document.getElementById('bfs-quick-add-modal');
    const modalOverlay = modal ? modal.querySelector('.bfs-quick-add-modal__overlay') : null;
    const modalClose = modal ? modal.querySelector('.bfs-quick-add-modal__close') : null;
    const modalHeader = modal ? modal.querySelector('.bfs-quick-add-modal__header') : null;
    const modalTitle = modalHeader ? modalHeader.querySelector('.bfs-quick-add-modal__title') : null;
    const modalSizesContainer = document.getElementById('bfs-quick-add-modal-sizes');
    const modalAddBtn = document.getElementById('bfs-quick-add-modal-add-btn');
    
    let currentSelectedVariantId = null;
    
    // Open modal with product data
    function openModal(productHandle, productData) {
        // Store product handle for later use
        if (!productHandle && productData && productData.handle) {
            productHandle = productData.handle;
        }
        if (!modal || !modalSizesContainer || !modalAddBtn) {
            console.error('Modal elements not found:', {
                modal: !!modal,
                modalSizesContainer: !!modalSizesContainer,
                modalAddBtn: !!modalAddBtn
            });
            return;
        }
        
        currentSelectedVariantId = null;
        
        // Clear previous sizes
        modalSizesContainer.innerHTML = '';
        
        // Find variant option index (prefer "size", otherwise use first option)
        let variantOptionIndex = 0;
        if (productData.options && Array.isArray(productData.options)) {
            const sizeIndex = productData.options.findIndex(function(opt) {
                // Handle both string options and object options
                const optionName = typeof opt === 'string' ? opt : (opt.name || opt);
                return optionName && optionName.toLowerCase() === 'size';
            });
            if (sizeIndex >= 0) {
                variantOptionIndex = sizeIndex;
            } else {
                // No size option, use first option (index 0)
                variantOptionIndex = 0;
            }
        }
        
        console.log('Product options:', productData.options, 'Variant option index:', variantOptionIndex);
        
        // Check if single variant product
        const isSingleVariant = productData.variants && productData.variants.length === 1 && 
                                productData.variants[0].title === "Default Title";
        
        // Build variant buttons (only if not single variant and has variants)
        if (productData.variants && productData.variants.length > 0 && !isSingleVariant) {
            // Reset display style for multi-variant products
            modalSizesContainer.style.display = '';
            let firstAvailableVariant = null;
            
            productData.variants.forEach(function(variant) {
                // Shopify variants use option1, option2, option3 properties
                let variantValue = null;
                if (variantOptionIndex === 0 && variant.option1) {
                    variantValue = variant.option1;
                } else if (variantOptionIndex === 1 && variant.option2) {
                    variantValue = variant.option2;
                } else if (variantOptionIndex === 2 && variant.option3) {
                    variantValue = variant.option3;
                } else if (variant.options && variant.options[variantOptionIndex]) {
                    // Fallback to options array if it exists
                    variantValue = variant.options[variantOptionIndex];
                }
                
                if (!variantValue) {
                    console.warn('Variant value not found for variant:', variant);
                    return; // Skip this variant if we can't find the value
                }
                
                // Check availability - Match product page logic: check inventory_quantity > 0
                // On live sites, the JSON API might return different data than Liquid
                let isAvailable = true; // Default to available
                
                // Priority 1: Check inventory_quantity (most reliable)
                // Match the product page logic: if inventory_quantity > 0, it's available
                if (variant.inventory_quantity !== undefined && variant.inventory_quantity !== null) {
                    // Check if inventory tracking is enabled
                    if (variant.inventory_management === 'shopify' && variant.inventory_policy === 'deny') {
                        // Tracked inventory with deny policy: must have quantity > 0
                        isAvailable = variant.inventory_quantity > 0;
                    } else if (variant.inventory_management === 'shopify' && variant.inventory_policy === 'continue') {
                        // Tracked inventory with continue policy: always available (backorders allowed)
                        isAvailable = true;
                    } else {
                        // No inventory tracking or not set: assume available
                        isAvailable = true;
                    }
                } else if (variant.available !== undefined && variant.available !== null) {
                    // Priority 2: Use 'available' property if inventory_quantity is not present
                    // Handle both boolean and string values
                    isAvailable = variant.available === true || variant.available === 'true' || variant.available === 1 || variant.available === '1';
                }
                // If neither exists, default to true (assume available)
                const variantId = variant.id;
                
                console.log('Variant:', variantValue, {
                    available: variant.available,
                    inventory_quantity: variant.inventory_quantity,
                    inventory_management: variant.inventory_management,
                    inventory_policy: variant.inventory_policy,
                    isAvailable: isAvailable,
                    variantId: variantId
                });
                
                // Track first available variant for auto-selection
                if (!firstAvailableVariant && isAvailable) {
                    firstAvailableVariant = variant;
                }
                
                const btn = document.createElement('button');
                btn.type = 'button';
                btn.className = 'bfs-quick-add-modal__size-btn';
                if (!isAvailable) {
                    btn.classList.add('is-unavailable');
                    btn.disabled = true;
                }
                btn.textContent = variantValue;
                btn.setAttribute('data-variant-id', variantId);
                btn.setAttribute('data-variant-available', isAvailable ? 'true' : 'false');
                btn.setAttribute('data-product-handle', productHandle);
                
                // Check if product has personalization (check option names, tags, or variant values)
                // This check is done once per variant, but it's lightweight
                let isPersonalised = false;
                
                // Check product tags (if available in productData)
                if (productData.tags && Array.isArray(productData.tags)) {
                    isPersonalised = productData.tags.some(function(tag) {
                        return tag && tag.includes('_badge:Personalise');
                    });
                }
                
                // Check option names
                if (!isPersonalised && productData.options && Array.isArray(productData.options)) {
                    isPersonalised = productData.options.some(function(opt) {
                        const optName = typeof opt === 'string' ? opt : (opt.name || opt);
                        return optName && optName.toLowerCase().includes('personalis');
                    });
                }
                
                // Also check if variant values are Yes/No (common pattern for personalization)
                if (!isPersonalised && variantValue && (variantValue.toLowerCase() === 'yes' || variantValue.toLowerCase() === 'no')) {
                    // Check if there are both Yes and No variants
                    const hasYesNo = productData.variants && productData.variants.some(function(v) {
                        const vValue = v.option1 || v.option2 || v.option3 || (v.options && v.options[0]);
                        return vValue && (vValue.toLowerCase() === 'yes' || vValue.toLowerCase() === 'no');
                    });
                    if (hasYesNo) {
                        isPersonalised = true;
                    }
                }
                
                if (isPersonalised) {
                    btn.setAttribute('data-is-personalised', 'true');
                }
                
                btn.addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    const btnAvailable = this.getAttribute('data-variant-available') === 'true';
                    if (!btnAvailable) return;
                    
                    const variantValueLower = this.textContent.trim().toLowerCase();
                    const btnIsPersonalised = this.getAttribute('data-is-personalised') === 'true';
                    const btnProductHandle = this.getAttribute('data-product-handle');
                    
                    // If personalized product and user clicked "Yes", navigate to PDP
                    if (btnIsPersonalised && variantValueLower === 'yes') {
                        if (btnProductHandle) {
                            window.location.href = '/products/' + btnProductHandle + '?variant=' + variantId;
                        } else {
                            console.error('Product handle not found for personalized variant');
                        }
                        return;
                    }
                    
                    // If personalized product and user clicked "No", add to cart immediately
                    if (btnIsPersonalised && variantValueLower === 'no') {
                        // Remove previous selection
                        modalSizesContainer.querySelectorAll('.bfs-quick-add-modal__size-btn').forEach(function(b) {
                            b.classList.remove('is-selected');
                        });
                        
                        // Add selection
                        btn.classList.add('is-selected');
                        currentSelectedVariantId = variantId;
                        
                        // Add to cart immediately
                        addToCart(variantId, btn, false).then(function() {
                            // Close modal after adding
                            setTimeout(function() {
                                closeModal();
                            }, 1000);
                        }).catch(function(error) {
                            console.error('Error adding to cart:', error);
                        });
                        return;
                    }
                    
                    // Remove previous selection
                    modalSizesContainer.querySelectorAll('.bfs-quick-add-modal__size-btn').forEach(function(b) {
                        b.classList.remove('is-selected');
                    });
                    
                    // Add selection
                    btn.classList.add('is-selected');
                    currentSelectedVariantId = variantId;
                    modalAddBtn.disabled = false;
                });
                
                modalSizesContainer.appendChild(btn);
            });
            
            // Auto-select first available variant and enable add to cart button
            if (firstAvailableVariant) {
                const firstBtn = modalSizesContainer.querySelector('[data-variant-id="' + firstAvailableVariant.id + '"]');
                if (firstBtn) {
                    firstBtn.classList.add('is-selected');
                    currentSelectedVariantId = firstAvailableVariant.id;
                    modalAddBtn.disabled = false;
                }
            }
        } else if (isSingleVariant && productData.variants && productData.variants.length > 0) {
            // Single variant product - hide sizes container and auto-select the variant
            modalSizesContainer.style.display = 'none';
            const singleVariant = productData.variants[0];
            currentSelectedVariantId = singleVariant.id;
            modalAddBtn.disabled = false;
        } else {
            // No variants found, ensure button is disabled
            modalSizesContainer.style.display = '';
            modalAddBtn.disabled = true;
        }
        
        // Check if product is personalized and show/hide header accordingly
        let isPersonalised = false;
        
        // Check product tags
        if (productData.tags && Array.isArray(productData.tags)) {
            isPersonalised = productData.tags.some(function(tag) {
                return tag && tag.includes('_badge:Personalise');
            });
        }
        
        // Check option names
        if (!isPersonalised && productData.options && Array.isArray(productData.options)) {
            isPersonalised = productData.options.some(function(opt) {
                const optName = typeof opt === 'string' ? opt : (opt.name || opt);
                return optName && optName.toLowerCase().includes('personalis');
            });
        }
        
        // Check if variant values are Yes/No (common pattern for personalization)
        if (!isPersonalised && productData.variants && productData.variants.length > 0) {
            const hasYesNo = productData.variants.some(function(v) {
                const vValue = v.option1 || v.option2 || v.option3 || (v.options && v.options[0]);
                return vValue && (vValue.toLowerCase() === 'yes' || vValue.toLowerCase() === 'no');
            });
            if (hasYesNo) {
                isPersonalised = true;
            }
        }
        
        // Show/hide header and set title based on personalization
        if (modalHeader && modalTitle) {
            if (isPersonalised) {
                modalTitle.textContent = 'Add personalisation?';
                modalHeader.style.display = 'block';
            } else {
                modalHeader.style.display = 'none';
            }
        }
        
        // Reset modal button text and styles (disabled state is already set by auto-selection above)
        modalAddBtn.textContent = 'Add to cart';
        modalAddBtn.classList.remove('is-adding', 'is-added');
        modalAddBtn.style.background = '';
        
        // Show modal
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
    }
    
    // Close modal
    function closeModal() {
        if (!modal) return;
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        currentSelectedVariantId = null;
        
        // Reset header visibility
        if (modalHeader) {
            modalHeader.style.display = 'none';
        }
    }
    
    // Modal event listeners
    if (modalClose) {
        modalClose.addEventListener('click', function(e) {
            e.preventDefault();
            closeModal();
        });
    }
    
    if (modalOverlay) {
        modalOverlay.addEventListener('click', function(e) {
            e.preventDefault();
            closeModal();
        });
    }
    
    // Close on Escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && modal && modal.getAttribute('aria-hidden') === 'false') {
            closeModal();
        }
    });
    
    // Handle modal add to cart
    if (modalAddBtn) {
        modalAddBtn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            if (!currentSelectedVariantId || this.disabled || this.classList.contains('is-adding')) {
                return;
            }
            
            // Disable button and show loading
            this.disabled = true;
            this.classList.add('is-adding');
            const originalText = this.textContent;
            this.textContent = 'Adding...';
            
            // Add to cart
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify({
                    id: currentSelectedVariantId,
                    quantity: 1
                })
            })
            .then(function(response) {
                if (!response.ok) {
                    return response.json().then(function(data) {
                        throw new Error(data.description || 'Failed to add to cart');
                    });
                }
                return response.json();
            })
            .then(function(item) {
                // Success
                modalAddBtn.classList.remove('is-adding');
                modalAddBtn.classList.add('is-added');
                modalAddBtn.textContent = 'Added!';
                
                // Update cart
                if (typeof window.updateCart !== 'undefined') {
                    window.updateCart();
                } else if (typeof Shopify !== 'undefined' && typeof Shopify.getCart !== 'undefined') {
                    Shopify.getCart(function(cart) {
                        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
                    });
                }
                
                // Dispatch event
                document.dispatchEvent(new CustomEvent('quickadd:added', {
                    detail: {
                        variantId: currentSelectedVariantId,
                        item: item
                    }
                }));
                
                // Close modal after delay
                setTimeout(function() {
                    closeModal();
                    modalAddBtn.classList.remove('is-added');
                    modalAddBtn.textContent = originalText;
                    modalAddBtn.disabled = false;
                }, 1000);
            })
            .catch(function(error) {
                console.error('Quick Add Modal Error:', error);
                modalAddBtn.classList.remove('is-adding');
                modalAddBtn.textContent = 'Error';
                modalAddBtn.style.background = '#dc3545';
                
                setTimeout(function() {
                    modalAddBtn.textContent = originalText;
                    modalAddBtn.style.background = '';
                    modalAddBtn.disabled = false;
                }, 2000);
            });
        });
    }

    // Add to cart function (reusable)
    function addToCart(variantId, buttonElement, isMobileIcon) {
        if (!variantId) {
            console.error('No variant ID provided');
            return Promise.reject(new Error('No variant ID provided'));
        }
        
        const originalText = buttonElement ? buttonElement.textContent : '';
        
        if (buttonElement) {
            buttonElement.disabled = true;
            buttonElement.classList.add('is-adding');
            
            // For mobile icons and variant size buttons, just add the is-adding class (CSS handles spinner)
            const isVariantButton = buttonElement.classList.contains('bfs-product-card__quick-add-size');
            if (!isMobileIcon && !buttonElement.classList.contains('bfs-product-card__quick-add-icon') && !isVariantButton) {
                buttonElement.textContent = 'Adding...';
            }
        }
        
        return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
                id: variantId,
                quantity: 1
            })
        })
        .then(function(response) {
            if (!response.ok) {
                return response.json().then(function(data) {
                    throw new Error(data.description || 'Failed to add to cart');
                });
            }
            return response.json();
        })
        .then(function(item) {
            // Success
            if (buttonElement) {
                buttonElement.classList.remove('is-adding');
                
                // For mobile icons and variant size buttons, just remove is-adding class (icon/text shows again)
                const isVariantButton = buttonElement.classList.contains('bfs-product-card__quick-add-size');
                if ((isMobileIcon && buttonElement.classList.contains('bfs-product-card__quick-add-icon')) || isVariantButton) {
                    // Icon/text is already visible (CSS animation stops), just enable button and restore selection state
                    buttonElement.disabled = false;
                    if (isVariantButton) {
                        // Keep the selected state for variant buttons
                        buttonElement.classList.add('is-selected');
                    }
                } else {
                    buttonElement.classList.add('is-added');
                    buttonElement.textContent = 'Added!';
                    
                    // Reset button after delay
                    setTimeout(function() {
                        buttonElement.classList.remove('is-added');
                        buttonElement.textContent = originalText;
                        buttonElement.disabled = false;
                    }, 2000);
                }
            }
            
            // Update cart count if function exists
            if (typeof window.updateCart !== 'undefined') {
                window.updateCart();
            } else if (typeof Shopify !== 'undefined' && typeof Shopify.getCart !== 'undefined') {
                Shopify.getCart(function(cart) {
                    // Trigger cart update event
                    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
                });
            }
            
            // Dispatch custom event for other scripts
            document.dispatchEvent(new CustomEvent('quickadd:added', {
                detail: {
                    variantId: variantId,
                    item: item
                }
            }));
            
            return item;
        })
        .catch(function(error) {
            // Error
            console.error('Quick Add Error:', error);
            if (buttonElement) {
                buttonElement.classList.remove('is-adding');
                
                // For mobile icons and variant size buttons, just remove is-adding class
                const isVariantButton = buttonElement.classList.contains('bfs-product-card__quick-add-size');
                if ((isMobileIcon && buttonElement.classList.contains('bfs-product-card__quick-add-icon')) || isVariantButton) {
                    // Icon/text is already visible, just enable button
                    buttonElement.disabled = false;
                } else {
                    buttonElement.textContent = 'Error';
                    buttonElement.style.background = '#dc3545';
                    
                    setTimeout(function() {
                        buttonElement.textContent = originalText;
                        buttonElement.style.background = '';
                        buttonElement.disabled = false;
                    }, 2000);
                }
            }
            throw error;
        });
    }

    // Handle mobile icon clicks
    function initMobileQuickAddIcons() {
        const icons = document.querySelectorAll('.bfs-product-card__quick-add-icon:not([data-initialized])');
        
        icons.forEach(function(icon) {
            icon.setAttribute('data-initialized', 'true');
            
            icon.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                
                const productHandle = this.getAttribute('data-product-handle');
                const singleVariantId = this.getAttribute('data-single-variant-id');
                
                // If single variant product, add directly to cart
                if (singleVariantId) {
                    addToCart(singleVariantId, this, true).catch(function(error) {
                        console.error('Error adding to cart:', error);
                    });
                    return false;
                }
                
                if (!productHandle) {
                    console.error('No product handle found on icon');
                    return false;
                }
                
                console.log('Icon clicked, product handle:', productHandle);
                
                // Fetch product data for multi-variant products
                fetch('/products/' + productHandle + '.json')
                    .then(function(response) {
                        if (!response.ok) {
                            throw new Error('Product not found: ' + response.status);
                        }
                        return response.json();
                    })
                    .then(function(data) {
                        console.log('Product data loaded:', data);
                        if (data && data.product) {
                            openModal(productHandle, data.product);
                        } else {
                            console.error('Invalid product data structure:', data);
                        }
                    })
                    .catch(function(error) {
                        console.error('Error loading product:', error);
                    });
                
                return false;
            });
        });
    }

    // Initialize Quick Add functionality
    function initQuickAdd() {
        const quickAddContainers = document.querySelectorAll('.bfs-product-card__quick-add:not([data-initialized])');
        
        quickAddContainers.forEach(function(container) {
            // Mark as initialized to prevent double-binding
            container.setAttribute('data-initialized', 'true');
            
            const productId = container.getAttribute('data-product-id');
            const sizeButtons = container.querySelectorAll('.bfs-product-card__quick-add-size');
            const addToCartBtn = container.querySelector('.bfs-product-card__quick-add-btn');
            
            let selectedVariantId = null;
            
            // Check if single variant product
            const singleVariantId = addToCartBtn ? addToCartBtn.getAttribute('data-single-variant-id') : null;
            
            if (singleVariantId && addToCartBtn) {
                // Single variant product - use the variant ID directly
                selectedVariantId = singleVariantId;
                addToCartBtn.disabled = false;
            } else if (sizeButtons.length > 0) {
                // Multi-variant product (no Quick Add button) - set up direct add to cart on variant click
                const isPersonalised = container.getAttribute('data-is-personalised') === 'true';
                const productHandle = container.getAttribute('data-product-handle');
                
                sizeButtons.forEach(function(btn) {
                    btn.addEventListener('click', function(e) {
                        e.preventDefault();
                        e.stopPropagation();
                        e.stopImmediatePropagation();
                        
                        const variantId = this.getAttribute('data-variant-id');
                        const isAvailable = this.getAttribute('data-variant-available') === 'true';
                        const variantValue = this.textContent.trim().toLowerCase();
                        const btnIsPersonalised = this.getAttribute('data-is-personalised') === 'true';
                        const btnProductHandle = this.getAttribute('data-product-handle') || productHandle;
                        
                        if (!isAvailable || !variantId) {
                            return false;
                        }
                        
                        // Check if this is a personalized product and user clicked "Yes"
                        if ((isPersonalised || btnIsPersonalised) && variantValue === 'yes') {
                            // Navigate to product page with variant selected
                            if (btnProductHandle) {
                                window.location.href = '/products/' + btnProductHandle + '?variant=' + variantId;
                            } else {
                                console.error('Product handle not found for personalized variant');
                            }
                            return false;
                        }
                        
                        // Remove previous selection
                        sizeButtons.forEach(function(b) {
                            b.classList.remove('is-selected');
                        });
                        
                        // Add selection to clicked button
                        this.classList.add('is-selected');
                        
                        // Add to cart directly (for "No" or non-personalized variants)
                        addToCart(variantId, this).catch(function(error) {
                            console.error('Quick Add Error:', error);
                        });
                        
                        return false;
                    });
                });
            }
            
            // Handle add to cart (only if button exists - single variant products)
            if (addToCartBtn) {
                addToCartBtn.addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    
                    if (!selectedVariantId || this.disabled || this.classList.contains('is-adding')) {
                        return false;
                    }
                    
                    // Use reusable addToCart function
                    addToCart(selectedVariantId, this).catch(function(error) {
                        console.error('Quick Add Error:', error);
                    });
                    return false;
                });
            }
            
            // Prevent card link from firing when clicking on quick add container (but allow buttons to work)
            container.addEventListener('click', function(e) {
                // Only prevent if clicking on the container itself, not on buttons inside
                if (e.target === container || (!e.target.closest('.bfs-product-card__quick-add-size') && !e.target.closest('.bfs-product-card__quick-add-btn'))) {
                    e.stopPropagation();
                }
            });
        });
    }
    
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            initQuickAdd();
            initMobileQuickAddIcons();
        });
    } else {
        initQuickAdd();
        initMobileQuickAddIcons();
    }
    
    // Re-initialize for dynamically loaded content (e.g., AJAX filters)
    document.addEventListener('DOMContentLoaded', function() {
        // Use MutationObserver to watch for new product cards
        const observer = new MutationObserver(function(mutations) {
            let shouldReinit = false;
            mutations.forEach(function(mutation) {
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === 1) {
                        if (node.classList && node.classList.contains('bfs-product-card__quick-add')) {
                            shouldReinit = true;
                        } else if (node.querySelector && node.querySelector('.bfs-product-card__quick-add')) {
                            shouldReinit = true;
                        } else if (node.classList && node.classList.contains('bfs-product-card')) {
                            shouldReinit = true;
                        }
                    }
                });
            });
            
            if (shouldReinit) {
                // Small delay to ensure DOM is fully updated
                setTimeout(function() {
                    initQuickAdd();
                    initMobileQuickAddIcons();
                }, 100);
            }
        });
        
        const container = document.body;
        if (container) {
            observer.observe(container, {
                childList: true,
                subtree: true
            });
        }
    });
    
    // Listen for boost-pfs events
    if (typeof window !== 'undefined') {
        window.addEventListener('boost-pfs-filter-products-loaded', function() {
            setTimeout(function() {
                initQuickAdd();
                initMobileQuickAddIcons();
            }, 100);
        });
        
        // Also listen for custom events that might be triggered
        window.addEventListener('boost-pfs-filter-render-complete', function() {
            setTimeout(function() {
                initQuickAdd();
                initMobileQuickAddIcons();
            }, 100);
        });
    }
    
})();
